<div class="general-info-tabs" [@summaryAccordian]>
  <div class="paddnig-left-desk">
    <div>
      <div>
        <div class="pl-md-0 ">
          <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
            <a
              *ngFor="let items of summaryContent?.menu; let i = index"
              class="nav-item nav-link"
              [ngClass]="items.name == 'Summary' ? 'active' : ''"
              id="accordion-tab{{ i }}"
              data-toggle="tab"
              href="#tab{{ i }}"
              role="tab"
              attr.aria-controls="tab{{ i }}"
              [attr.aria-selected]="items.name == 'Summary' ? true : false"
              >{{ items.name }}
            </a>
          </div>
        </div>
      </div>

      <div class="tab-content py-3" id="nav-tabContent">
        <ng-container>
          <div
            class="tab-pane fade show active"
            id="tab0"
            role="tabpanel"
            aria-labelledby="accordion-tab0"
          >
            <div
              class="d-flex"
              *ngIf="
                summaryPanel?.SummaryDetails?.SummaryPendingItem ||
                summaryPanel?.SummaryDetails?.SummaryBoundItem
              "
            >
              <div>
                <p>
                  {{ ((summaryContent?.menu)[0]?.submenu)[0]?.name }}
                </p>
                <span>{{
                  pageName == 'Bound'
                    ? summaryPanel?.SummaryDetails?.SummaryBoundItem
                        ?.InsuredName
                    : summaryPanel?.SummaryDetails?.SummaryPendingItem
                        ?.InsuredName
                }}</span>
              </div>
              <div *ngIf="pageName != 'Additional'">
                <p>
                  {{ ((summaryContent?.menu)[0]?.submenu)[1]?.name }}
                </p>
                <span>{{
                  pageName == 'Bound'
                    ? summaryPanel?.SummaryDetails?.SummaryBoundItem
                        ?.PolicyStatus
                    : summaryPanel?.SummaryDetails?.SummaryPendingItem
                        ?.SubmissionStatus
                }}</span>
              </div>

              <div *ngIf="pageName == 'Additional'">
                <p>
                  EFFECTIVE DATE OF CHANGE
                </p>
                <span>{{
                  summaryPanel?.SummaryDetails?.SummaryPendingItem
                    ?.EffectiveDateOfChange
                }}</span>
              </div>

              <div *ngIf="pageName != 'Additional'">
                <p>
                  {{
                    pageName == 'Bound'
                      ? 'POLICY NUMBER'
                      : ((summaryContent?.menu)[0]?.submenu)[2]?.name
                  }}
                </p>
                <span>{{
                  pageName == 'Bound'
                    ? summaryPanel?.SummaryDetails?.SummaryBoundItem
                        ?.PolicyNumber
                    : summaryPanel?.SummaryDetails?.SummaryPendingItem
                        ?.SubmissionId
                }}</span>
              </div>
              <div *ngIf="pageName == 'Additional'">
                <p>
                  <!-- {{ ((summaryContent?.menu)[0]?.submenu)[2]?.name }} -->
                  POLICY NUMBER
                </p>
                <span>{{
                  summaryPanel?.SummaryDetails?.SummaryBoundItem?.PolicyNumber
                }}</span>
              </div>
              <div *ngIf="pageName != 'Additional'">
                <p>
                  {{ ((summaryContent?.menu)[0]?.submenu)[3]?.name }}
                </p>
                <span>{{
                  pageName == 'Bound'
                    ? summaryPanel?.SummaryDetails?.SummaryBoundItem
                        ?.SubmissionType
                    : summaryPanel?.SummaryDetails?.SummaryPendingItem
                        ?.SubmissionType
                }}</span>
              </div>

              <div *ngIf="pageName == 'Additional'">
                <p>
                  ENDORSEMENT STATUS
                </p>

                <span>{{
                  summaryPanel?.SummaryDetails?.SummaryBoundItem
                    ?.EndorsementStatus
                }}</span>
              </div>

              <div *ngIf="pageName != 'Additional'">
                <p>
                  {{ ((summaryContent?.menu)[0]?.submenu)[4]?.name }}
                </p>
                <span>{{
                  pageName == 'Bound'
                    ? summaryPanel?.SummaryDetails?.SummaryBoundItem?.Program
                    : summaryPanel?.SummaryDetails?.SummaryPendingItem?.Program
                }}</span>
              </div>
              <div *ngIf="pageName != 'Additional' && pageName != 'Declined'">
                <p>
                  {{ ((summaryContent?.menu)[0]?.submenu)[5]?.name }}
                </p>
                <span class="total">{{
                  pageName == 'Bound'
                    ? summaryPanel?.SummaryDetails?.SummaryBoundItem
                        .SubmissionType == 'Endorsement'
                      ? summaryPanel?.SummaryDetails?.SummaryBoundItem
                          .EndorsementTotal
                      : summaryPanel?.SummaryDetails?.SummaryBoundItem
                          ?.PolicyTotal || 0
                    : summaryPanel?.SummaryDetails?.SummaryPendingItem
                        ?.PolicyTotal || 0
                }}
               <!-- ARC -->
               <i *ngIf="(prodName === 'General Liability') 
               && (
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step1A' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step1B' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step1C' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step2A' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step2B' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step2C' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step3A' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step3B' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step3C' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'EHelpUWReview'               
               )" data-tooltip="" style="cursor: help;" data-bs-toggle="tooltip" title="Please be aware that the premiums displayed are for informational purposes only and serve as an indication. Any formally quoted premiums for General Liability need to be referred to and issued by ArtisanEdge Underwriters. It's important to note that these premiums may change significantly after a thorough review of all underlying quotes/policies and loss history." class="fa fa-question-circle text-muted" ref="tooltip" ></i>
              
               <!-- AXL -->
               <i *ngIf="(prodName === 'Excess Liability') 
               && (
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step1A' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step1B' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step1C' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step2A' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step2B' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step2C' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step2D' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step3A' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step3B' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'Step3C' ||
               summaryPanel?.SummaryDetails?.SummaryPendingItem?.PolicyStatus === 'EHelpUWReview'               
               )" data-tooltip="" style="cursor: help;" data-bs-toggle="tooltip" title="Please be aware that the premiums displayed are for informational purposes only and serve as an indication. Any formally quoted premiums for Excess Liability need to be referred to and issued by ArtisanEdge Underwriters. It's important to note that these premiums may change significantly after a thorough review of all underlying quotes/policies and loss history." class="fa fa-question-circle text-muted" ref="tooltip" ></i>
              </span>
              </div>

              <div *ngIf="pageName == 'Additional'">
                <p>
                  Endorsement Total
                </p>
                <span class="total">{{
                  summaryPanel?.SummaryDetails?.SummaryPendingItem
                    ?.EndorsementTotal || 0
                }}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container>
          <div
            class="tab-pane fade"
            id="tab1"
            role="tabpanel"
            aria-labelledby="accordion-tab1"
          >
            <div
              class="tab-pane fade show active"
              id="tab0"
              role="tabpanel"
              aria-labelledby="accordion-tab0"
            >
              <div class="d-flex" *ngIf="summaryPanel?.PremiumDetails">
                <div
                  *ngFor="
                    let items of summaryPanel?.PremiumDetails?.PremiumItems
                  "
                >
                  <p>
                    {{ items?.Name }}
                  </p>
                  <span>{{ items?.Amount }}</span>
                </div>

                <div
                  *ngFor="
                    let items of summaryPanel?.PremiumDetails?.TaxAndFeeItems
                  "
                >
                  <p>
                    {{ items?.Name }}
                  </p>
                  <span>{{ items?.Amount }}</span>
                </div>

                <div>
                  <p>
                    {{ ((summaryContent?.menu)[1]?.submenu)[4]?.name }}
                  </p>
                  <span class="total">{{
                    summaryPanel?.PremiumDetails?.PolicyTotal
                  }}</span>
                </div>
              </div>
              <div class="prem-advisory" *ngIf="pageName != 'Bound'">
                {{ ((summaryContent?.menu)[1]?.submenu)[5]?.name }}
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!isEnPending">
          <div
            *ngIf="
              prodName === 'General Liability' &&
              !summaryPanel?.InspectionDetails?.HasInspection
                ? false
                : true
            "
            class="tab-pane fade"
            id="tab2"
            role="tabpanel"
            aria-labelledby="accordion-tab2"
          >
            <div
              class="tab-pane fade show active"
              id="tab0"
              role="tabpanel"
              aria-labelledby="accordion-tab0"
            >
              <div
                class="d-flex coverage"
                *ngIf="pageName == 'Bound' && prodName == 'General Liability'"
              >
                <div>
                  <p>
                    INSPECTION STATUS
                  </p>
                  <span
                    >{{ summaryPanel?.InspectionDetails?.InspectionStatus }}
                  </span>
                </div>

                <div>
                  <p>
                    DUE DATE
                  </p>
                  <span>
                    {{ summaryPanel?.InspectionDetails?.DueDate }}
                  </span>
                </div>

                <div>
                  <p>
                    INSURED EMAIL ADDRESS
                  </p>
                  <span>
                    {{ summaryPanel?.InspectionDetails?.InsuredEmailAddress }}
                  </span>
                </div>
              </div>

              <!-- GL Liability-->
              <ae-general-liability
                class="width100"
                *ngIf="
                  summaryPanel?.CoverageDetails?.Name == 'General Liability'
                "
                [summaryAPIData]="summaryPanel"
                [summarySitecoreData]="summaryContent"
                [pageName]="pageName"
              ></ae-general-liability>

              <!-- PL Liability-->
              <pollution-liability
                class="width100"
                *ngIf="
                  summaryPanel?.CoverageDetails?.Name ==
                  'Pollution Liability Coverage'
                "
                [summaryAPIData]="summaryPanel"
                [summarySitecoreData]="summaryContent"
                [pageName]="pageName"
              ></pollution-liability>

              <!-- PR Liability-->
              <ae-professional-liability
                class="width100"
                *ngIf="
                  summaryPanel?.CoverageDetails?.Name ==
                  'Professional Liability'
                "
                [summaryAPIData]="summaryPanel"
                [summarySitecoreData]="summaryContent"
                [pageName]="pageName"
              ></ae-professional-liability>

              <!-- BR Liability-->
              <builders-liability
                class="width100"
                *ngIf="summaryPanel?.CoverageDetails?.Name == 'Builders\' Risk'"
                [summaryAPIData]="summaryPanel"
                [summarySitecoreData]="summaryContent"
                [pageName]="pageName"
              ></builders-liability>

              <!-- CE Liability-->
              <contractors-liability
                class="width100"
                *ngIf="
                  summaryPanel?.CoverageDetails?.Name ==
                  'Contractors\' Equipment'
                "
                [summaryAPIData]="summaryPanel"
                [summarySitecoreData]="summaryContent"
                [pageName]="pageName"
              ></contractors-liability>

              <!-- EX Liability -->
              <excess-liability
                class="width100"
                *ngIf="
                  summaryPanel?.CoverageDetails?.Name == 'Excess Liability'
                "
                [summaryAPIData]="summaryPanel"
                [summarySitecoreData]="summaryContent"
                [pageName]="pageName"
              ></excess-liability>
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div
            *ngIf="
              prodName === 'General Liability' ||
              prodName === 'Excess Liability' ||
              isEnPending
            "
            class="tab-pane fade"
            [attr.id]="
              isEnPending ||
              (prodName === 'General Liability' &&
                !summaryPanel?.InspectionDetails?.HasInspection)
                ? 'tab2'
                : 'tab3'
            "
            role="tabpanel"
            aria-labelledby="accordion-tab3"
          >
            <div
              class="tab-pane fade show active"
              id="tab0"
              role="tabpanel"
              aria-labelledby="accordion-tab0"
            >
              <div class="d-flex">
                <div
                  class="row"
                  *ngIf="summaryPanel?.OtherCoverageDetails?.CoverageItems"
                >
                  <div
                    *ngFor="
                      let others of summaryPanel?.OtherCoverageDetails
                        ?.CoverageItems
                    "
                    style="display: contents;"
                  >
                    <div *ngIf="prodName == 'General Liability'">
                      <div
                        [class]="
                          others?.Name == 'Excess'
                            ? 'col-sm-12 col-lg-12'
                            : 'col-sm-12 col-md-12'
                        "
                        *ngIf="others?.Name != 'General Liability'"
                      >
                        <p>
                          {{ others?.Name }}
                        </p>
                        <span>{{
                          others?.Name == 'Excess'
                            ? (others?.Limits)[0]?.Value
                            : others?.CoverageOption
                        }}</span>
                      </div>
                    </div>

                    <!-- Excess Liability -->

                    <div *ngIf="prodName == 'Excess Liability'">
                      <div class="col-sm-12">
                        <p>
                          {{ others?.Name }}
                        </p>
                        <span>{{ others.Description }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isEnPending">
          <div
            class="tab-pane fade"
            id="tab3"
            role="tabpanel"
            aria-labelledby="accordion-tab4"
          >
            <div
              class="tab-pane fade show active"
              id="tab0"
              role="tabpanel"
              aria-labelledby="accordion-tab0"
            >
              <div class="d-flex">
                <div class="col-md-3">
                  <p>
                    {{ ((summaryContent?.menu)[3]?.submenu)[0]?.name }}
                  </p>
                  <span>
                    {{
                      (summaryPanel?.PaymentDetail
                        ?.InstallmentBillingOption)[0]
                    }}<br />
                  </span>
                </div>

                <div class="col-md-3">
                  <p>
                    {{ ((summaryContent?.menu)[3]?.submenu)[1]?.name }}
                  </p>
                  <span>
                    {{
                      (summaryPanel?.PaymentDetail
                        ?.PaperlessPremiumFinancing)[0]
                    }}<br />
                  </span>
                </div>

                <div class="col-md-3">
                  <p>
                    {{ ((summaryContent?.menu)[3]?.submenu)[2]?.name }}
                  </p>
                  <span>
                    {{ (summaryPanel?.PaymentDetail?.AgencyBill)[0] }}<br />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!isEnPending">
          <div
            class="tab-pane fade"
            [attr.id]="
              (prodName === 'General Liability' &&
                summaryPanel?.InspectionDetails?.HasInspection) ||
              prodName === 'Excess Liability'
                ? 'tab4'
                : 'tab3'
            "
            role="tabpanel"
            aria-labelledby="accordion-tab4"
          >
            <div
              class="tab-pane fade show active"
              id="tab0"
              role="tabpanel"
              aria-labelledby="accordion-tab0"
            >
              <div class="d-flex">
                <div class="col-md-3" *ngIf="pageName == 'Bound'">
                  <p>
                    PAYMENT PLAN
                  </p>
                  <span
                    *ngFor="
                      let paymentPlan of summaryPanel?.PaymentDetail
                        ?.PaymentPlan
                    "
                  >
                    {{ paymentPlan }}<br />
                  </span>
                </div>
                <div
                  class="col-md-3"
                  *ngIf="
                    pageName != 'Bound' &&
                    summaryPanel?.PaymentDetail?.InstallmentBillingOption
                      ?.length
                  "
                >
                  <p>
                    {{
                      prodName == 'General Liability' ||
                      prodName == 'Excess Liability'
                        ? ((summaryContent?.menu)[4]?.submenu)[0]?.name
                        : ((summaryContent?.menu)[3]?.submenu)[0]?.name
                    }}
                  </p>
                  <span>{{
                    (summaryPanel?.PaymentDetail?.InstallmentBillingOption)[0]
                  }}</span>
                </div>

                <div
                  class="col-md-3"
                  *ngIf="
                    pageName == 'Bound' &&
                    summaryPanel?.PaymentDetail?.MailPaymentTo
                  "
                >
                  <p>
                    MAIL PAYMENT TO
                  </p>
                  <span
                    *ngFor="
                      let mailPaymentTo of summaryPanel?.PaymentDetail
                        ?.MailPaymentTo
                    "
                  >
                    {{ mailPaymentTo }}<br />
                  </span>
                </div>

                <div
                  class="col-md-3"
                  *ngIf="
                    pageName != 'Bound' &&
                    summaryPanel?.PaymentDetail?.PaperlessPremiumFinancing
                  "
                >
                  <p>
                    {{
                      prodName == 'General Liability' ||
                      prodName == 'Excess Liability'
                        ? ((summaryContent?.menu)[4]?.submenu)[1]?.name
                        : ((summaryContent?.menu)[3]?.submenu)[1]?.name
                    }}
                  </p>
                  <span>{{
                    (summaryPanel?.PaymentDetail?.PaperlessPremiumFinancing)[0]
                  }}</span>
                </div>

                <div
                  class="col-md-3"
                  *ngIf="
                    pageName == 'Bound' &&
                    summaryPanel?.PaymentDetail?.OvernightMail
                  "
                >
                  <p *ngIf="summaryContent?.menu">
                    OVERNIGHT MAIL
                  </p>
                  <span
                    *ngFor="
                      let overnightMail of summaryPanel?.PaymentDetail
                        ?.OvernightMail
                    "
                  >
                    {{ overnightMail }}<br />
                  </span>
                </div>

                <div
                  class="col-md-3"
                  *ngIf="
                    pageName != 'Bound' &&
                    summaryPanel?.PaymentDetail?.AgencyBill
                  "
                >
                  <p>
                    {{
                      prodName == 'General Liability' ||
                      prodName == 'Excess Liability'
                        ? ((summaryContent?.menu)[4]?.submenu)[2]?.name
                        : ((summaryContent?.menu)[3]?.submenu)[2]?.name
                    }}
                  </p>
                  <span>{{
                    (summaryPanel?.PaymentDetail?.AgencyBill)[0]
                  }}</span>
                </div>

                <div
                  class="col-md-3"
                  *ngIf="
                    pageName == 'Bound' &&
                    summaryPanel?.PaymentDetail?.WireTransferOrACH
                  "
                >
                  <p>
                    WIRE TRANSFER OR ACH
                  </p>
                  <span
                    *ngFor="
                      let wireTransfer of summaryPanel?.PaymentDetail
                        ?.WireTransferOrACH
                    "
                  >
                    {{ wireTransfer }}<br />
                  </span>
                </div>
                <div
                  class="col-md-3"
                  *ngIf="
                    pageName == 'Bound' &&
                    summaryPanel?.PaymentDetail?.PaymentDetails
                  "
                >
                  <p>Payment Details</p>
                  <span
                    *ngFor="
                      let paymentDetails of summaryPanel?.PaymentDetail
                        ?.PaymentDetails
                    "
                  >
                    {{ paymentDetails }}<br />
                  </span>
                </div>
                <div
                  class="col-md-3"
                  *ngIf="
                    pageName == 'Bound' && summaryPanel?.PaymentDetail?.Contact
                  "
                >
                  <p>Contact</p>
                  <span
                    *ngFor="let contact of summaryPanel?.PaymentDetail?.Contact"
                  >
                    {{ contact }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <!-- Bound Summary -->
  </div>
</div>
